import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./i18n.js";
import "./styles.css";
import { App } from "./App.js";
import { registerNativeLifecycle } from "./nativeLifecycle.js";
import { registerServiceWorker } from "./registerServiceWorker.js";
import { registerAnalyticsLifecycle } from "./analytics.js";
import { useClientStore } from "./store.js";

const root = document.getElementById("root");
if (root === null) throw new Error("web.root.missing");

void registerNativeLifecycle();
registerServiceWorker();
registerAnalyticsLifecycle(() => {
  const state = useClientStore.getState();
  return { view: state.view };
});

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
